import React from 'react';
import { KeyValuePair } from 'tailwindcss/types/config';
import { ServiceBox } from './ServiceBox';
import { DialogBox, mapDialogMessage, useDialog } from '../../../comps/dialog';

type ServiceProps = {
  services: any[];
  addService: (service: string) => void;
  removeService: (service: string) => void;
  logoSrc: string;
  logoAlt: string;
  serviceText: KeyValuePair<string, string>;
  removeConfirmation?: {
    message: string;
    cancelButtonText?: string;
    closeButtonText?: string;
    confirmOnCancel?: boolean;
  }
};

export default function Service({ services, addService, removeService, logoSrc, logoAlt, serviceText, removeConfirmation }: ServiceProps) {

  const dialog = useDialog('Confirmation');

  if(!Array.isArray(services) || services.length === 0) return null;

  const terms = serviceText?.Terms ? serviceText.Terms.split(/[\r\n]/) : [];

  const handleRemove = (service: string) => {
    if(!removeConfirmation) {
      removeService(service);
      return;
    }

    dialog
      .show(removeConfirmation.message)
      .then(() => removeService(service))
      .catch(() => {});
  }

  return (
    <>
      <ServiceBox services={services} addService={addService} removeService={handleRemove} title={serviceText.Label}>
        <img height="80" src={logoSrc} alt={logoAlt} />
        <div>
          <div className='tw-text-[16px] sa-text-green'>{serviceText.Title}</div>
          {terms.map((term, index) => <div key={index}>{term}</div>)}
        </div>
      </ServiceBox>
      <DialogBox open={dialog.open} title={dialog.title} onClose={dialog.close} cancelButtonText={removeConfirmation?.cancelButtonText} closeButtonText={removeConfirmation?.closeButtonText} confirmOnCancel={removeConfirmation?.confirmOnCancel}>
        { mapDialogMessage(dialog.message) }
      </DialogBox>
    </>
  )

}